module.exports = __webpack_public_path__ + "static/media/view5.17db566a.jpg";